import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { WebsiteAuditService } from '../website-audit.service';
import { SidenavService } from 'src/app/sidenav/sidenav.service';

@Component({
  selector: 'app-overview',
  templateUrl: './overview.component.html',
  styleUrls: ['./overview.component.css'],
})
export class OverviewComponent implements OnInit, OnDestroy {
  constructor(
    private sidenavService: SidenavService,
    private websiteAuditService: WebsiteAuditService,
  ) {}

  private subs: Subscription = new Subscription();

  public infoCards: any = [
    {
      title: 'UX',
      value: 0,
      icon: 'icon-ux',
      issues: 0,
      valueKey: 'uxAverage',
      failed: false,
      progress: 0,
    },
    {
      title: 'CR',
      value: 0,
      icon: 'icon-cr',
      issues: 0,
      valueKey: 'conversionAverage',
      failed: false,
      progress: 0,
    },
    {
      title: 'SEO',
      value: 0,
      icon: 'icon-seo',
      issues: 0,
      valueKey: 'seoAverage',
      failed: false,
      progress: 0,
    },
    {
      title: 'GEO',
      value: 0,
      icon: 'icon-geo',
      issues: 0,
      valueKey: 'geoAverage',
      failed: false,
      progress: 0,
    },
    {
      title: 'Technical',
      value: 0,
      icon: 'icon-technical',
      issues: 0,
      valueKey: 'technicalAverage',
      failed: false,
      progress: 0,
    },
    {
      title: 'Diagnostics',
      value: 0,
      icon: 'icon-diagnostics',
      issues: 0,
      valueKey: 'diagnosticsAverage',
      failed: false,
      progress: 0,
    },
    {
      title: 'Agentic Ecommerce',
      value: 0,
      icon: '',
      issues: 0,
      valueKey: 'agenticEcommerce',
      failed: false,
      progress: 100,
    },
  ];

  public topCriticalIssues: any = [];

  public isLoading: boolean = false;

  private selectedTask: any;

  public showLoader: boolean = false;
  public loaderPercentage: number = 0;
  public loaderTexts: any = [
    'Initializing audit...',
    'Collecting site data...',
    'Reviewing structure...',
    'Checking key elements...',
    'Analyzing performance signals...',
    'Evaluating overall quality...',
    'Identifying potential issues...',
    'Cross-checking results...',
    'Compiling insights...',
    'Finalizing audit overview...',
  ];
  public loaderLineIndex: number = 0;

  public noData: boolean = false;

  ngOnInit(): void {
    this.subs.add(
      this.websiteAuditService.getSelectedAuditTask().subscribe((res: any) => {
        if (res) {
          this.noData = false;
          this.selectedTask = res;

          this.infoCards.forEach((card: any) => {
            card.progress = 0;
          });

          this.constructInfoCards();
          this.constructTopCriticalIssues();

          const SEOCard = this.infoCards.find(
            (card: any) => card.title == 'SEO',
          );
          const GEOCard = this.infoCards.find(
            (card: any) => card.title == 'GEO',
          );

          if (
            (this.selectedTask?.organicProgress?.progress >= 100 &&
              this.selectedTask?.organicProgress?.status != 'failed') ||
            res['website_name']
          ) {
            SEOCard.progress = 100;
            GEOCard.progress = 100;
            SEOCard.failed = false;
            GEOCard.failed = false;

            this.getAuditGeneral();
          } else if (
            this.selectedTask?.organicProgress?.progress < 100 &&
            this.selectedTask?.organicProgress?.status != 'failed'
          ) {
            SEOCard.progress = this.selectedTask?.organicProgress?.progress;
            GEOCard.progress = this.selectedTask?.organicProgress?.progress;
          } else {
            SEOCard.progress = 100;
            GEOCard.progress = 100;
            SEOCard.failed = true;
            GEOCard.failed = true;
          }
        } else {
          this.noData = true;
          this.infoCards.forEach((card: any) => {
            card.progress = 100;
            card.value = 0;
          });
        }
      }),
    );

    this.subs.add(
      this.websiteAuditService.getAuditTasksLoading().subscribe((res: any) => {
        this.isLoading = res;
      }),
    );
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  lastTaskAuditGeneralCall: string = '';
  getAuditGeneral() {
    function getDomainFromUrl(url: string): string | null {
      try {
        const normalized = url.startsWith('http') ? url : `https://${url}`;

        const { hostname } = new URL(normalized);
        return hostname.replace(/^www\./, '');
      } catch {
        return null;
      }
    }
    const domainFromUrl = getDomainFromUrl(this.selectedTask?.url);

    const SEOCard = this.infoCards.find((card: any) => card.title == 'SEO');
    const GEOCard = this.infoCards.find((card: any) => card.title == 'GEO');

    if (this.lastTaskAuditGeneralCall == this.selectedTask?.taskId) {
      return;
    }
    this.lastTaskAuditGeneralCall = this.selectedTask?.taskId;
    // this.websiteAuditService.updateAuditTasksLoading(true);
    this.subs.add(
      this.websiteAuditService
        .getAuditGeneral({
          domain: domainFromUrl,
        })
        .subscribe({
          next: (res: any) => {
            const obj = res?.general_obj;
            // this.websiteAuditService.updateAuditTasksLoading(false);

            try {
              SEOCard.value = Math.round(obj?.seo_performance_score || 0);
              SEOCard.issues = obj?.seo_issues_default || 0;
              SEOCard.failed = false;

              const geoValue = Math.round(
                ((obj?.gemini_performance || 0) + (obj?.gpt_performance || 0)) /
                  2,
              );

              GEOCard.failed = false;
              GEOCard.value = geoValue;
              GEOCard.issues =
                obj?.seo_issues_gemini + obj?.seo_issues_chatgpt || 0;
            } catch (e) {
              SEOCard.failed = true;
              GEOCard.failed = true;
              console.log(e);
            }
          },
          error: (err: any) => {
            SEOCard.value = 0;
            GEOCard.value = 0;
            SEOCard.failed = true;
            GEOCard.failed = true;
            // this.websiteAuditService.updateAuditTasksLoading(false);
          },
        }),
    );
  }

  constructInfoCards() {
    const overallProgress = this.selectedTask?.progress;

    this.infoCards.forEach((element: any) => {
      if (element.title == 'UX') {
        if (this.selectedTask?.crStatus == 'failed') {
          element.value = 0;
          element.issues = [];
          element.progress = 100;
          element.failed = true;
        } else {
          element.failed = false;
          element.value = Math.round(
            this.selectedTask?.auditRankings?.[element.valueKey] || 0,
          );

          let uxIssues = 0;
          this.selectedTask?.auditRankings?.UX?.forEach((issue: any) => {
            uxIssues += issue?.notWorkingWell?.length || 0;
          });
          element.issues = uxIssues;

          if (overallProgress < 100) {
            element.progress = Math.round(this.selectedTask?.uxProgress || 0);
          } else {
            element.progress = 100;
          }
        }
      } else if (element.title == 'CR') {
        if (this.selectedTask?.crStatus == 'failed') {
          element.value = 0;
          element.issues = [];
          element.progress = 100;
          element.failed = true;
        } else {
          element.failed = false;
          element.value = Math.round(
            this.selectedTask?.auditRankings?.[element.valueKey] || 0,
          );

          let crIssues = 0;
          this.selectedTask?.auditRankings?.Conversion?.forEach(
            (issue: any) => {
              crIssues += issue?.notWorkingWell?.length || 0;
            },
          );
          element.issues = crIssues;

          if (overallProgress < 100) {
            element.progress = Math.round(this.selectedTask?.uxProgress || 0);
          } else {
            element.progress = 100;
          }
        }
      } else if (element.title == 'Diagnostics') {
        if (this.selectedTask?.errorStatus == 'failed') {
          element.value = 0;
          element.issues = 0;
          element.progress = 100;
          element.failed = true;
        } else {
          element.failed = false;
          element.value = Math.round(this.selectedTask?.errorAverage || 0);
          element.issues = this.selectedTask?.errors?.length || 0;

          if (overallProgress < 100) {
            element.progress = Math.round(
              this.selectedTask?.errorProgress || 0,
            );
          } else {
            element.progress = 100;
          }
        }
      } else if (element.title == 'Technical') {
        if (this.selectedTask?.technicalStatus == 'failed') {
          element.value = 0;
          element.issues = [];
          element.progress = 100;
          element.failed = true;
        } else {
          element.failed = false;
          element.value = Math.round(
            this.selectedTask?.auditRankings?.metricsRankingAverage || 0,
          );
          element.issues = Math.round(
            (this.selectedTask?.auditRankings?.technicalCategories?.stats
              ?.fail || 0) +
              (this.selectedTask?.auditRankings?.technicalCategories?.stats
                ?.warning || 0),
          );

          if (overallProgress < 100) {
            element.progress = Math.round(
              this.selectedTask?.insightProgress || 0,
            );
          } else {
            element.progress = 100;
          }
        }
      } else if (element.title == 'Agentic Ecommerce') {
        if (
          !this.selectedTask?.auditRankings?.agenticEcommerce ||
          this.selectedTask?.auditRankings?.agenticEcommerce?.status == 'failed'
        ) {
          element.value = '-';
          element.issues = [];
          element.failed = false;
          element.progress = 100;
        } else {
          element.failed = false;
          element.value = Math.round(
            this.selectedTask?.auditRankings?.agenticEcommerce?.score || 0,
          );
          element.issues = Math.round(
            this.selectedTask?.auditRankings?.agenticEcommerce?.issues || 0,
          );

          if (overallProgress < 100) {
            element.progress = Math.round(
              this.selectedTask?.agenticProgress || 0,
            );
          } else {
            element.progress = 100;
          }
        }
      }
    });

    this.setOverallProgress(overallProgress);
  }

  getImpactLevel(num: number, returnCssClass: boolean = false): string {
    if (typeof num != 'number') {
      if (returnCssClass) return '';
      return 'No Data';
    }

    if (num < 50) {
      if (returnCssClass) return 'low_value';
      return 'Critical';
    }

    if (num >= 50 && num < 80) {
      if (returnCssClass) return 'mid_value';
      return 'Warning';
    }

    if (returnCssClass) return 'high_value';
    return 'Good';
  }

  constructTopCriticalIssues() {
    const notWorkingWell: any = [];
    const auditRankings = this.selectedTask?.auditRankings || {};

    try {
      Object.entries(auditRankings).forEach((el: any) => {
        const issues = Array.isArray(el?.[1]) ? el?.[1] : [];
        issues.forEach((issue: any) => {
          if (issue?.notWorkingWell?.length > 0) {
            const mappedElements = [...issue.notWorkingWell].map((m: any) => {
              return {
                ...m,
                category: el[0],
                impact: this.getImpactLevel(m?.score),
                severity: this.getImpactLevel(m?.score),
                title: m?.text,
                description: m?.reason,
              };
            });

            notWorkingWell.push(...mappedElements);
          }
        });
      });

      this.topCriticalIssues = notWorkingWell
        .sort((a: any, b: any) => b?.score - a?.score)
        .slice(0, 3);
    } catch (e) {
      this.topCriticalIssues = [];
    }
  }

  setOverallProgress(percentage: number) {
    this.loaderPercentage = percentage;

    this.loaderLineIndex =
      Math.round(this.loaderPercentage / this.loaderTexts.length) - 1;

    this.showLoader = percentage < 100;
  }

  goToTabIndex(index: number) {
    this.sidenavService.updateActiveTabIndex(index);
  }

  addAudit() {
    sessionStorage.setItem('addAudit', 'true');
    this.sidenavService.updateActiveTabIndex(7);
  }
}
